// React and Hooks
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

function Footer() {
  const location = useLocation();
  const socials = [
      {
        icon: <FacebookIcon />,
        link: "https://www.facebook.com/CreativeTim/",
      },
      {
        icon: <TwitterIcon />,
        link: "https://twitter.com/creativetim",
      },
      {
        icon: <GitHubIcon />,
        link: "https://github.com/creativetimofficial",
      },
      {
        icon: <YouTubeIcon />,
        link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
      },
    ]

  useEffect(() => {
    // Check if the script is already added
    const scriptId = 'nyimbo-script';
    if (!document.getElementById(scriptId)) {
      // Define _tid on the window object
      window._tid = process.env.REACT_APP_TID;

      // Add CSS to prevent tracking image from affecting layout
      const style = document.createElement('style');
      style.id = 'tracking-image-fix';
      style.textContent = `
        img[src*="a2k.rw/st/img.php"] {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }
        body::after {
          content: none !important;
          display: none !important;
        }
      `;
      document.head.appendChild(style);

      // Create a script element
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://t.a2kstats.com/';
      script.async = true;

      // Append to head
      document.head.appendChild(script);

      // Cleanup function to remove the script when the component unmounts
      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
        // Clean up the global variable if necessary
        delete window._tid;
      };
    }
  }, [location]); // Run effect on navigation


  // useEffect(() => {
  //   const scriptContent = `
  //     var _tid = "g87igjghf5gg83esded9"; 
  //     const _hati = document.createElement('script');
  //     _hati.src = 'https://a2k.rw/st/nyimbo.js';
  //     document.head.appendChild(_hati); 
  //   `;

  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.innerHTML = scriptContent;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <div>
      <MKTypography variant="button" fontWeight="regular">
        All rights reserved. Copyright &copy; {date} by{" "}
        <MKTypography
          component="a"
          href="https://www.kazananguvu.com"
          target="_blank"
          rel="noreferrer"
          variant="button"
          fontWeight="regular"
        >
          HanyeLeo
        </MKTypography>
        .
      </MKTypography>
      <div className="flex gap-2 justify-center">
        {socials.map((social) => (
          <a key={social.link} href={social.link} target="_blank" rel="noreferrer">
            {social.icon}
          </a>
        ))}
      </div>
    </div>
  );
}

export default {
  // Other properties if any
  copyright: <Footer />,
};
